<template lang="html">
  <div class="">    
    <div class="row">
      <div class="col-sm-2">
        <input v-model="filterKey" placeholder="Search..." class="form-control">
      </div>
      <div class="col-sm-10">
        <button class="btn btn-default" @click="clearSearch">Limpiar</button>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-12">
        <players-table :players="players" :filter-key.sync="filterKey" :list-type="listType"></players-table>
      </div>
    </div>
  </div>
</template>

<script>
import PlayersTable from '../components/PlayersTable'
import {
  getRegistrations
} from '../vuex/getters'
import * as actions from '../vuex/actions'

export default {
  vuex: {
    getters: {
      registrations: getRegistrations
    }
  },
  data() {
    return {
      filterKey: '',
      listType: 'ready'
    };
  },
  computed: {
    players() {
      let players = []
      this.registrations.forEach((s) => {
        if (s.status >= 3) {
          let player = s
          players.push(player)
        }
      })
      return players
    }
  },
  components: { PlayersTable }
};
</script>

<style lang="css">
</style>



/** WEBPACK FOOTER **
 ** PlayersInGame.vue?1dfb0869
 **/